var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-v4-Item-Expanded",
    transform: "translate(-285.000000, -81.000000)",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(286.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.18181818,7.99992649 L18.1818182,8.00007351",
    id: "Line",
    transform: "translate(8.000000, 8.000000) rotate(45.000000) translate(-8.000000, -8.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.18181818,8.00008633 L18.1818182,7.99991367",
    id: "Line",
    transform: "translate(8.000000, 8.000000) rotate(-45.000000) translate(-8.000000, -8.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIcon);
export default __webpack_public_path__ + "static/media/ModalIcon.1e585a4c83b1f4e6412c258fcf95585b.svg";
export { ForwardRef as ReactComponent };